// TODO add tests
import numeral from 'numeral';

const isNextValue = (v, valueToNextUnit) =>
  valueToNextUnit > 0 ? v < valueToNextUnit : v;

const getKey = (v, showUnit, valueToNextUnit) => {
  if (showUnit) {
    return isNextValue(v, valueToNextUnit)
      ? 'units:measure_cm'
      : 'units:measure_m';
  }

  return 'units:only_value';
};

const formatMeasure = ({
  value,
  t,
  valueToNextUnit = 250,
  showUnit = true,
}) => {
  const realValue = isNextValue(value, valueToNextUnit) ? value : value / 100;
  const formattedValue = numeral(realValue).format('0[.]0');

  return t(getKey(value, showUnit, valueToNextUnit), { value: formattedValue });
};

export default formatMeasure;
